export const enum DefaultSectionsOrder {
    Nodes = 100,
    Skeletons = 200,
    Materials = 300,
    Textures = 400,
    PostProcesses = 500,
    RenderingPipelines = 600,
    EffectLayers = 700,
    ParticleSystems = 800,
    SpriteManagers = 900,
    AnimationGroups = 1000,
    GUIs = 1100,
    FrameGraphs = 1200,
    Atmosphere = 1300,
    Sounds = 1400,
    AudioV2 = 1500,
}

export const enum DefaultCommandsOrder {
    SpritePlay = 600,
    LightActive = 700,
    CameraActive = 700,
    GizmoActive = 800,
    AnimationGroupPlay = 900,
    FrameGraphPlay = 900,
    MeshBoundingBox = 1000,
    GuiHighlight = 1000,
    MeshVisibility = 1100,
    GuiVisibility = 1100,
    EditNodeMaterial = 1100,
    EditParticleSystem = 1100,
    EditNodeGeometry = 1100,
    EditNodeRenderGraph = 1100,
    Dispose = 10000,
}
